import React, { useCallback, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { OTHER_STORES_ANCHOR, STORE_LINKS } from "./siteLinks";
import { useDismiss } from "./useDismiss";

/** «Другие магазины» в шапке: все «другие магазины» одним списком. Открывается наведением и нажатием, закрывается уходом мыши, кликом мимо или Esc. */
function StoresMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const close = useCallback(() => setOpen(false), []);
  useDismiss(ref, open, close);

  return (
    <div
      ref={ref}
      className="relative px-2 xl:px-3"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={close}
    >
      <button
        type="button"
        className={`-mx-3 block whitespace-nowrap px-3 py-2 font-semibold leading-7 lg:text-center lg:text-lg xl:text-xl ${
          open ? "text-blue-700 dark:text-blue-300" : "text-blue-500 dark:text-[#cccccc]"
        }`}
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        Другие магазины
      </button>
      {open ? (
        <div className="born-item stores-menu absolute right-0 top-full z-20 rounded-lg bg-gray-200 px-4 py-3 dark:bg-zinc-900">
          <div className="stores-menu-grid">
            {STORE_LINKS.map((link) => (
              <NavLink key={link.id} to={link.to} className="nav-link whitespace-nowrap" onClick={close}>
                {link.label}
              </NavLink>
            ))}
          </div>
          <Link to={OTHER_STORES_ANCHOR} className="stores-menu-all" onClick={close}>
            Все магазины на главной →
          </Link>
        </div>
      ) : null}
    </div>
  );
}

export default StoresMenu;
